module.exports = __webpack_public_path__ + "static/keyboard-background-d8bcd322e19758b391fc2c4c2942b0e5.jpg";